<section class="cmn-innerpage-wrapper quotation">
  <ag-grid-angular
    style="width: 100%"
    [rowData]="rowData"
    [columnDefs]="columnDefs"
    [defaultColDef]="defaultColDef"
    [rowSelection]="rowSelection"
    [suppressRowClickSelection]="true"
    [paginationPageSizeSelector]="paginationPageSizeSelector"
    [class]="themeClass"
    (cellClicked)="onCellClicked($event)"
  />
</section>
